import {
  SET_PURCHASES
} from 'app/actions/types';

import {
  getPurchases as getPurchasesSvc
} from 'app/services/purchases';

export const getPurchases = params => async dispatch => {
  let purchases = await getPurchasesSvc(params);

  if (purchases) {
    dispatch({
      type: SET_PURCHASES,
      payload: purchases.params
    });
  }

  return purchases;
}

export const setPurchaseParams = params => async dispatch => {
  dispatch({
    type: SET_PURCHASES,
    payload: params
  });
}
